export default "__VITE_PUBLIC_ASSET__abde71a0__"